import type { FC } from 'react';
import { useLocation } from 'react-router-dom';
import type { LoadedAppShellData } from 'src/components/layout/app-shell/use-app-shell-data';
import type { ActiveSection } from 'src/components/layout/header/types';
import { ExternalLink, Link } from 'src/components/navigation/link';
import { useOptionalAuthenticatedMonolithUser } from 'src/hooks/use-monolith-user';

export const isStorageActive = (pathname: string, hash: string) =>
  pathname.startsWith('/storage') ||
  (pathname.startsWith('/platform') && hash.startsWith('#/storage'));

type SecondaryNavStorageProps = {
  activeSection: ActiveSection;
  appShellData: LoadedAppShellData;
};

export const SecondaryNavStorage: FC<SecondaryNavStorageProps> = ({
  activeSection,
  appShellData,
}) => {
  const { hash, pathname } = useLocation();
  const monolithUser = useOptionalAuthenticatedMonolithUser();

  const locationsNewNav =
    appShellData.storageServiceRoot?.response.data._links?.getLocationsOverview;

  if (!activeSection.storage) return null;

  return (
    <div
      className={`
        flex flex-col flex-wrap items-stretch gap-x-xl gap-y-md
        md:flex-row md:items-center
        legacy:gap-x-[2rem] legacy:gap-y-[1rem]
      `}
      data-testid="secondary-nav"
    >
      {monolithUser?.isShipper && (
        <>
          <Link
            mode="secondary"
            to="/storage/offers"
            isActive={
              pathname.startsWith('/storage/offers') ||
              (pathname.startsWith('/platform') &&
                hash.startsWith('#/storage/offers'))
            }
          >
            Auctions
          </Link>

          <ExternalLink
            mode="secondary"
            href={`${PRISMA_CONFIG.angularUrl}/#/storage/booking`}
          >
            FCFS Booking
          </ExternalLink>
        </>
      )}

      {monolithUser?.isSso && (
        <>
          <Link
            mode="secondary"
            to="/storage/offers"
            isActive={
              pathname.startsWith('/storage/offers') ||
              (pathname.startsWith('/platform') &&
                hash.startsWith('#/storage/offers') &&
                !hash.startsWith('#/storage/offers/create'))
            }
          >
            Manage Offers
          </Link>

          <ExternalLink
            mode="secondary"
            href={`${PRISMA_CONFIG.angularUrl}/#/storage/offers/create`}
            isActive={
              pathname.startsWith('/platform') &&
              hash.startsWith('#/storage/offers/create')
            }
          >
            Create Offer
          </ExternalLink>

          {!locationsNewNav && (
            <Link
              mode="secondary"
              to="/storage/locations"
              isActive={
                pathname.startsWith('/storage/locations') ||
                (pathname.startsWith('/platform') &&
                  hash.startsWith('#/storage/locations'))
              }
            >
              Storage Locations
            </Link>
          )}
        </>
      )}

      {locationsNewNav && (
        <Link mode="secondary" to="/storage/locations-new">
          Storage Locations
        </Link>
      )}
    </div>
  );
};
